import React, { useState } from "react";
import { CONFIG } from "../config";

function MediaContact() {
  const trueOrFalseDisableButton = JSON.parse(
    localStorage.getItem("trueOrFalseDisableButtont")
  );
  const [submitted, setSubmitted] = useState(trueOrFalseDisableButton);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const res = await fetch("/api/mediaOutreach", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ firstName, lastName, email, subject, message }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Something went wrong. Please try again.");
      }
      setFirstName("");
      setLastName("");
      setEmail("");
      setSubject("");
      setMessage("");
      setSubmitted(true);
      localStorage.setItem("trueOrFalseDisableButtont", JSON.stringify(true));
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const isFormValid = firstName && lastName && email && subject && message;

  return (
    <div>
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px" }}>
            <h1
              style={{
                fontSize: "clamp(2rem, 4vw, 2.5rem)",
                fontWeight: "700",
                color: "#1a1a2e",
                marginBottom: "16px",
                letterSpacing: "-0.02em",
              }}
            >
              Media Outreach
            </h1>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#555",
                lineHeight: "1.7",
              }}
            >
              Are you a journalist or media professional? Get in touch with us
              for press inquiries, interview requests, or story collaborations.
            </p>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "50px 0 80px 0" }}>
        <div style={{ maxWidth: "700px", margin: "0 auto" }}>
          {/* Contact Info Cards */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "20px",
              marginBottom: "40px",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "24px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e8eef3",
              }}
            >
              <p
                style={{
                  fontSize: "0.85rem",
                  color: "#666",
                  marginBottom: "8px",
                }}
              >
                Email
              </p>
              <a
                href={`mailto:${CONFIG.CONTACT_EMAIL}`}
                style={{
                  fontSize: "1rem",
                  color: "#004d99",
                  fontWeight: "600",
                  textDecoration: "none",
                }}
              >
                {CONFIG.CONTACT_EMAIL}
              </a>
            </div>
          </div>

          {/* Form or Success Message */}
          {submitted ? (
            <div
              style={{
                background: "rgba(0, 77, 153, 0.05)",
                borderRadius: "16px",
                padding: "48px",
                textAlign: "center",
                border: "1px solid rgba(0, 77, 153, 0.1)",
              }}
            >
              <div
                style={{
                  width: "64px",
                  height: "64px",
                  borderRadius: "50%",
                  backgroundColor: "#004d99",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 24px auto",
                }}
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  color: "#1a1a2e",
                  marginBottom: "12px",
                }}
              >
                Message Sent Successfully
              </h2>
              <p style={{ fontSize: "1rem", color: "#555", lineHeight: "1.7" }}>
                Thank you for reaching out. Our team will review your inquiry
                and respond within 48 hours.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "40px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.3rem",
                    fontWeight: "600",
                    color: "#1a1a2e",
                    marginBottom: "24px",
                  }}
                >
                  Send us a message
                </h2>

                {/* Name Fields */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                    marginBottom: "20px",
                  }}
                >
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        color: "#1a1a2e",
                        marginBottom: "8px",
                      }}
                    >
                      First Name
                    </label>
                    <input
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        fontSize: "1rem",
                        border: "1px solid #e8eef3",
                        borderRadius: "10px",
                        outline: "none",
                        transition: "border-color 0.2s ease",
                      }}
                      onFocus={(e) => (e.target.style.borderColor = "#004d99")}
                      onBlur={(e) => (e.target.style.borderColor = "#e8eef3")}
                    />
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        color: "#1a1a2e",
                        marginBottom: "8px",
                      }}
                    >
                      Last Name
                    </label>
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        fontSize: "1rem",
                        border: "1px solid #e8eef3",
                        borderRadius: "10px",
                        outline: "none",
                        transition: "border-color 0.2s ease",
                      }}
                      onFocus={(e) => (e.target.style.borderColor = "#004d99")}
                      onBlur={(e) => (e.target.style.borderColor = "#e8eef3")}
                    />
                  </div>
                </div>

                {/* Email */}
                <div style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      color: "#1a1a2e",
                      marginBottom: "8px",
                    }}
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      padding: "14px 16px",
                      fontSize: "1rem",
                      border: "1px solid #e8eef3",
                      borderRadius: "10px",
                      outline: "none",
                      transition: "border-color 0.2s ease",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#004d99")}
                    onBlur={(e) => (e.target.style.borderColor = "#e8eef3")}
                  />
                </div>

                {/* Subject */}
                <div style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      color: "#1a1a2e",
                      marginBottom: "8px",
                    }}
                  >
                    Subject
                  </label>
                  <input
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      padding: "14px 16px",
                      fontSize: "1rem",
                      border: "1px solid #e8eef3",
                      borderRadius: "10px",
                      outline: "none",
                      transition: "border-color 0.2s ease",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#004d99")}
                    onBlur={(e) => (e.target.style.borderColor = "#e8eef3")}
                  />
                </div>

                {/* Message */}
                <div style={{ marginBottom: "24px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      color: "#1a1a2e",
                      marginBottom: "8px",
                    }}
                  >
                    Message
                  </label>
                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows={5}
                    style={{
                      width: "100%",
                      padding: "14px 16px",
                      fontSize: "1rem",
                      border: "1px solid #e8eef3",
                      borderRadius: "10px",
                      outline: "none",
                      resize: "vertical",
                      transition: "border-color 0.2s ease",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#004d99")}
                    onBlur={(e) => (e.target.style.borderColor = "#e8eef3")}
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={!isFormValid || submitting}
                  style={{
                    width: "100%",
                    padding: "16px",
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#fff",
                    backgroundColor: isFormValid && !submitting ? "#004d99" : "#ccc",
                    border: "none",
                    borderRadius: "10px",
                    cursor: isFormValid && !submitting ? "pointer" : "not-allowed",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  {submitting ? "Sending…" : "Send Message"}
                </button>

                {error && (
                  <p
                    style={{
                      fontSize: "0.85rem",
                      color: "#c0392b",
                      textAlign: "center",
                      marginTop: "12px",
                    }}
                  >
                    {error}
                  </p>
                )}

                {!isFormValid && (
                  <p
                    style={{
                      fontSize: "0.85rem",
                      color: "#666",
                      textAlign: "center",
                      marginTop: "12px",
                    }}
                  >
                    Please fill in all fields to submit
                  </p>
                )}
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default MediaContact;
